"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconShop = void 0;
var React = __importStar(require("react"));
var IconShop = function (props) { return (React.createElement("svg", __assign({ width: "24px", height: "24px", viewBox: "0 0 40 40" }, props),
    React.createElement("g", { fill: "none", "fill-rule": "evenodd" },
        React.createElement("g", { fill: "#445" },
            React.createElement("g", null,
                React.createElement("g", null,
                    React.createElement("g", null,
                        React.createElement("path", { d: "M32.326 3.333c.172 0 .33.088.423.228l.04.075 3.835 8.778v.002c.015.033.017.07.024.106.006.031.018.06.018.091v2.377c0 .85-.35 1.625-.925 2.219l-.149.145v18.808c0 .248-.178.454-.414.497l-.09.008H4.912c-.249 0-.455-.179-.497-.415l-.008-.09v-18.81c-.613-.561-1.01-1.315-1.067-2.151l-.008-.211v-2.377c.001-.03.013-.06.02-.092.006-.035.008-.072.022-.105v-.002l3.836-8.778c.069-.158.212-.267.378-.296l.085-.007h24.652zM16.39 23.293H9.187v12.364h7.202V23.293zm13.308-6.617c-.647 1.007-1.85 1.688-3.23 1.688-1.382 0-2.587-.68-3.234-1.688-.647 1.007-1.851 1.688-3.23 1.688-1.383 0-2.588-.68-3.235-1.688-.647 1.007-1.85 1.688-3.23 1.688-1.382 0-2.588-.68-3.235-1.688-.647 1.007-1.85 1.688-3.23 1.688-.51 0-.995-.095-1.438-.263l-.217-.09v17.646h2.759v-12.87c0-.247.178-.453.414-.496l.09-.008h8.213c.248 0 .454.179.497.414l.008.09v12.87h17.183V18.012c-.498.223-1.057.352-1.65.352-1.382 0-2.588-.68-3.235-1.688zm1.433 4.99c.297 0 .537.237.537.528v7.279c0 .29-.24.527-.537.527H20.537c-.297 0-.537-.236-.537-.527v-7.279c0-.291.24-.527.537-.527zm-.537 1.056h-9.52v6.223h9.52v-6.223zm-14.33-9.6h-5.455v1.868c0 1.303 1.222 2.363 2.724 2.363 1.448 0 2.632-.977 2.725-2.208l.005-.155V13.12zm6.464 0h-5.454v1.868c0 1.303 1.222 2.363 2.724 2.363 1.448 0 2.632-.977 2.725-2.208l.005-.155V13.12zm6.465 0h-5.454v1.868c0 1.303 1.222 2.363 2.724 2.363 1.448 0 2.632-.977 2.724-2.208l.006-.155V13.12zm-19.394 0H4.343v1.868c0 1.303 1.223 2.363 2.725 2.363 1.447 0 2.632-.977 2.724-2.208l.006-.155V13.12zm25.859 0h-5.455v1.868c0 1.303 1.222 2.363 2.725 2.363 1.447 0 2.631-.977 2.724-2.208l.006-.155V13.12zm-3.661-8.779h-4.282l2.358 7.768h5.318l-3.394-7.768zm-15.13 0h-3.525l-2.357 7.768h5.314l.569-7.768zm9.793 0h-4.117l1.127 7.768h5.347l-2.357-7.768zm-5.137 0h-3.643l-.568 7.768h5.338l-1.127-7.768zm-9.236 0H8.004L4.61 12.111h5.318l2.358-7.768z", transform: "translate(-223 -1699) translate(108 1548) translate(55 151) translate(60)" })))))))); };
exports.IconShop = IconShop;
exports.IconShop.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconShop;
